
import { createContext, useContext, useRef, useState } from "react";
import toast , { Toaster }  from 'react-hot-toast';
import Loading from './loading/loading'

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const loadingRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const showLoading = () => setIsLoading(true);
  const hideLoading = () => setIsLoading(false);

 

  return (
    <LoadingContext.Provider value={{ loadingRef, isLoading, showLoading, hideLoading, toast }}>
        <div className="loadingContainer" style={{ display: isLoading ? 'flex' : 'none' }}>
             <Loading />
        </div>

   <Toaster
      position="bottom-center"
      toastOptions={{
        style: {
          background: '#2d3748', // Dark slate
          color: '#f7fafc', // Almost white
          minWidth: '300px',
        },
        success: {
          icon: '✅',
          duration: 5000,
          iconTheme: {
            primary: '#48bb78', // Green
            secondary: '#2d3748',
          },
        },
        error: {
          icon: '❌',
          duration: 6000,
          iconTheme: {
            primary: '#f56565', // Red
            secondary: '#2d3748',
          },
        },
      }}
      containerStyle={{
        animation: 'slideIn 0.3s ease-out',
      }}
    />

      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
